import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ContentWrapper from '../content_wrapper/ContentWrapper';
import { Icon, Input, Button, message } from 'antd';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { CONTACTS_GROUPS_RESOURCE_NAME } from '../../config/constants';
import { _callResource } from '../../context/_callResource';
import { ApiError } from '../../utils/errors';
import TEXTS from "../../locale/texts";

const { TextArea } = Input;

class NewContactGroup extends Component {
  state = {
    PAYLOAD: {
      name: null,
      note: null
    },
    contactCreated: false,
    error: false,
    errorMessage: null,
    isLoading: false,
    isEdit: !!this.props.match.path.match(/edit/),
    createContactsGroupsIsLoading: false,
    createContactsGroupsError: null,
    updateContactsGroupsIsLoading: false,
    updateContactsGroupsError: null
  };

  callResource = _callResource.bind(this);
  groupNameInput = React.createRef();

  componentDidMount() {
    const { match, location } = this.props;
    window.scrollTo(0, 198);

    if (match.path.match(/edit/)) {
      if (location.state) {
        this.setState({
          PAYLOAD: location.state,
        });
      } else {
        this.getContactGroupData();
      }
    }

    this.groupNameInput.current.focus();
  };

  toAllContactGroups = () => {
    this.props.history.push('/phonebook/groups');
  };

  toContactsGroupDetails = () => {
    const { id } = this.props;
    this.props.history.push(`/phonebook/groups/${id}`);
  };

  onInputChange = (key, value) => {
    this.setState(state => ({
      PAYLOAD: {
        ...state.PAYLOAD,
        [key]: value
      },
      message: ''
    }));
  };

  createContactsGroup = () => {
    const { PAYLOAD } = this.state;
    const { promiseCancelToken, addNotification, lang } = this.props;
    this.callResource({
      resourceName: CONTACTS_GROUPS_RESOURCE_NAME,
      apiClassName: 'contactsGroups',
      action: 'create',
      apiCallParams: PAYLOAD,
      promiseCancelToken,
      onSuccess: () => {
        addNotification(TEXTS.groupIsCreated[lang]);
        this.toAllContactGroups();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        message.error(`${TEXTS.groupWasNotCreated[lang]}: ${errorMessage}.`, 5);
      }
    });
  };

  updateContactsGroup = () => {
    const { promiseCancelToken, addNotification, lang } = this.props;
    const { PAYLOAD } = this.state;
    this.callResource({
      resourceName: CONTACTS_GROUPS_RESOURCE_NAME,
      apiClassName: 'contactsGroups',
      action: 'update',
      apiCallParams: PAYLOAD,
      promiseCancelToken,
      onSuccess: () => {
        addNotification(TEXTS.groupIsSaved[lang]);
        this.toContactsGroupDetails();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        message.error(`${TEXTS.groupWasNotSaved[lang]}: ${errorMessage}.`, 5);
      }
    });
  };

  getContactGroupData = () => {
    const { id, promiseCancelToken } = this.props;
    this.callResource({
      resourceName: CONTACTS_GROUPS_RESOURCE_NAME,
      apiClassName: 'contactsGroups',
      action: 'getOneOf',
      apiCallParams: { id },
      promiseCancelToken,
      onSuccess: (response) => {
        this.setState({ PAYLOAD: response.data });
      }
    });
  };

  render() {
    const { lang } = this.props;
    const {
      PAYLOAD,
      createContactsGroupsIsLoading,
      updateContactsGroupsIsLoading,
      isEdit
    } = this.state;
    const { name, note } = PAYLOAD;
    const saving = createContactsGroupsIsLoading || updateContactsGroupsIsLoading;

    return (
      <ContentWrapper>
        <h4 className="form-row title text-pink text-uppercase mb-4">
          {isEdit ? TEXTS.editGroupTitle[lang] : TEXTS.createGroupTitle[lang]}
        </h4>
        <div>
          <div className="form-row mb-4">
            <label className='t-bold'>
              {TEXTS.groupNameLabel[lang]}
              <span className="star-required text-pink">*</span>
            </label>
            <Input
              size="large"
              name="name"
              placeholder={TEXTS.groupNameLabel[lang]}
              ref={this.groupNameInput}
              value={name}
              onChange={({ target: { name, value } }) =>
                this.onInputChange(name, value)
              }
            />
          </div>
          <div className="form-row mb-4">
            <label className='t-bold'>{TEXTS.comment[lang]}</label>
            <TextArea
              rows="3"
              name="note"
              value={note}
              placeholder={TEXTS.comment[lang]}
              onChange={({ target: { name, value } }) =>
                this.onInputChange(name, value)
              }
            />
          </div>
          <div className="form-row">
            <Button
              type="primary"
              size="large"
              style={{padding: '0 20px', height: 50, marginRight: 15, fontSize: 16}}
              loading={saving}
              disabled={saving || !PAYLOAD.name}
              onClick={() => {isEdit ? this.updateContactsGroup() : this.createContactsGroup()}}
            >
              {isEdit ? TEXTS.btnSaveGroup[lang] : TEXTS.btnCreateGroup[lang]}
            </Button>
            <Button
              size="large"
              style={{padding: '0 20px', height: 50, marginRight: 15, fontSize: 16}}
              onClick={() => {
                if (isEdit) {
                  this.toContactsGroupDetails();
                } else {
                  this.toAllContactGroups();
                }
              }}>
              {TEXTS.btnCancel[lang]}
            </Button>
          </div>
        </div>
      </ContentWrapper>
    )
  }
}

export default withRouter(NewContactGroup);
